// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Actions-actions-2uvYh {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  padding-inline: 10px;\n}\n.Actions-container-3E8CG {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  margin-top: auto;\n  gap: 10px;\n}\n", ""]);
// Exports
exports.locals = {
	"actions": "Actions-actions-2uvYh",
	"container": "Actions-container-3E8CG"
};
module.exports = exports;
